import { createApp } from "vue";
import DOMUtils from "@utils/dom.utils";
import SecurityUtils from "@utils/security.utils";
import ToastNotification from "./components/ToastNotification";
import ToastNotificationContainer from "./components/ToastNotificationContainer";
import { isNull } from "@utils/var.check";
import AppInstanceUtils from "@plugins/common/service/app.instance.utils";

const getToastNotificationContainer = (plugin) => {
  const toastContainer = DOMUtils.el(".toast-notification-container");

  if (toastContainer) {
    plugin.containerComponent = ToastContainerComponent; //toastContainer.__vueParentComponent.ctx;
  } else {
    const container = DOMUtils.createDivInBody({
      class: "toast-notification-container",
    });
    const app = createApp(ToastNotificationContainer, {
      //parent: root,
    });
    AppInstanceUtils.installCommonPlugin(app);
    plugin.containerComponent = app.mount(container);
    ToastContainerComponent = plugin.containerComponent;
    DOMUtils.replaceComponentWrapperWithComponentElement(plugin.containerComponent);
  }

  return plugin.containerComponent;
};

let ToastContainerComponent;

const Plugin = {
  install(app, options) {
    this.containerComponent = null;
    this.params = options;

    const showToast = (notification, params) => {
      const container = getToastNotificationContainer(Plugin);
      return container.add(notification, params);
    };

    const removeToast = (params) => {
      const root = params && params.root ? params.root : Plugin;
      const container = getToastNotificationContainer(root);
      container.remove(params);
    };

    const removeAllToasts = (params) => {
      const root = params && params.root ? params.root : Plugin;
      const container = getToastNotificationContainer(root);
      container.removeAll();
    };

    const setDefaultParams = (type, params) => {
      //set default params
      if (!isNull(params)) {
        params.kind = type;

        // not to sanitize subtitle when set to false, default = true
        params.sanitizeSubTitle = !isNull(params.sanitizeSubTitle) ? params.sanitizeSubTitle : true;
        if (params.sanitizeSubTitle === true) {
          params.subTitle = !isNull(params.subTitle)
            ? SecurityUtils.sanitizeText(params.subTitle)
            : "";
        }

        //SLSSIT-5751 some toast require to not sanitize caption hence default sanitizeCaption will be true
        params.sanitizeCaption = !isNull(params.sanitizeCaption) ? params.sanitizeCaption : true;
        if (params.sanitizeCaption === true) {
          params.caption = !isNull(params.caption)
            ? SecurityUtils.sanitizeText(params.caption)
            : "";
        }
        params.hideCloseButton = !isNull(params.hideCloseButton) ? params.hideCloseButton : false;
        params.hasTimeout = !isNull(params.hasTimeout) ? params.hasTimeout : true;
      }
    };

    /**
     * Plugin API
     */
    app.config.globalProperties.$toast = {
      show(type, params) {
        if (typeof type === "string") {
          switch (type) {
            case "success":
            case "warning":
            case "info":
            case "error":
            case "gamification":
              setDefaultParams(type, params);
              return showToast(ToastNotification, params);
            default:
              break;
          }
        }
      },

      remove(params = {}) {
        removeToast(params);
      },

      removeAll(params = {}) {
        removeAllToasts(params);
      },
    };
    this.$toast = app.config.globalProperties.$toast;
  },
};

export default Plugin;
